import { NgModule } from '@angular/core';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { DxValidatorModule } from 'devextreme-angular';
import { AirlinePreferenceFormComponent } from './airline-preference-form.component';
import { AirlinePreferenceFormService } from './airline-preference-form.service';

@NgModule({
  imports: [SharedModule, DxValidatorModule],
  declarations: [AirlinePreferenceFormComponent],
  exports: [AirlinePreferenceFormComponent],
  providers: [AirlinePreferenceFormService],
})
export class AirlinePreferenceFormModule {}
